var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCameraDiable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.78 3.22a.75.75 0 0 1 0 1.06l-3.37 3.371.005-.004-1.665 1.665V9.31L7.06 18h.002l-1.5 1.5H5.56l-1.28 1.28a.75.75 0 0 1-1.061-1.06l.362-.363A3.001 3.001 0 0 1 1.5 16.5v-9a3 3 0 0 1 3-3h9.75a3 3 0 0 1 2.631 1.558L19.72 3.22a.75.75 0 0 1 1.06 0zm-5.057 3.996A1.5 1.5 0 0 0 14.25 6H4.5A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h.44L15.723 7.216z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.75a.75.75 0 1 1 1.5 0v10.474c0 1.246-1.43 1.949-2.416 1.188l-2.834-2.186v.274a3 3 0 0 1-3 3H9A.75.75 0 1 1 9 18h5.25a1.5 1.5 0 0 0 1.5-1.5V12a.75.75 0 1 1 1.5 0v2.331L21 17.224V6.75z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCameraDiable);
export default __webpack_public_path__ + "static/media/Icons_Camera-diable.37e9d3aa1580f36dec27d661f2ba2fb7.svg";
export { ForwardRef as ReactComponent };